import { Dispatch } from "redux";
import queryString from "query-string";

import {
  getRequirements,
  getRequirementsSuccess,
  getRequirementsError,
  setTotalAmountOfRequirementsByFilter,
} from "../../store/ducks/requirementList";

import {
  fetchRequirements as fetchRequirementsService,
} from "../../services/requirements";

import Requirement from "../../domains/Requirement";

export function fetchRequirements(
  filter?: string,
  pageIndex?: number,
  pageSize?: number,
) {
  return (dispatch: Dispatch) => {
    dispatch(getRequirements());
    const params = filter
      ? `${filter}&${queryString.stringify({
        pageIndex,
        pageSize,
        "order[createdAt]": "desc",
      })}`
      : `?${queryString.stringify({
        pageIndex,
        pageSize,
        "order[createdAt]": "desc",
      })}`;

    fetchRequirementsService(params)
      .then((data: { rows: Array<Requirement>; count: number }) => {
        const requirementsRows = data.rows.map(row => {
          return {
            id: row.id,
            alias: row.alias,
            country: row.port.country.name,
            port: row.port.name,
            vessel: row.vessel,
            deal: row.dealNumber,
            system: `${row.system.site.name} ${row.system.name}`,
            category: row.category,
            user: row.username,
            deadline: row.deadline as string,
            status: row.status
          };
        });
        dispatch(setTotalAmountOfRequirementsByFilter(data.count));
        dispatch(getRequirementsSuccess(requirementsRows));
      })
      .catch(() => {
        dispatch(getRequirementsError());
      });
  };
}